module.exports = __webpack_public_path__ + "img/inter-back.fe97770f.svg";